import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: any) => ({
  container: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    height: 'max-content',
    margin: '0 7rem',
    padding: '3rem 0',
    backgroundColor: theme.whiteColor,
    borderTop: `1px solid ${theme.snowColor}`,
  },
  title: {
    color: theme.darkSlateGrayColor,
    textTransform: 'uppercase',
  },
  link: {
    position: 'absolute',
    right: '0',
    top: '3rem',
    textTransform: 'uppercase',
    color: theme.lightCoralColor,
  },
  previewContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    gap: '3rem',
    width: '100%',
    marginTop: '3rem',
  },
  previewItem: {
    width: '15rem',
    height: '10rem',
    border: '1px solid',
  },
}));

export default useStyles;
